import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import PtoCreditForm from "./_form"

interface Employee {
  id: number
  name: string
}

interface YearOption {
  value: number
  label: string
}

interface Props {
  credit: {
    id: number
    user_id: number | null
    credit_year: number
    hours_requested: number
    reason: string
  }
  employees: Employee[]
  year_options: YearOption[]
  errors?: Record<string, string[]>
}

export default function Edit({
  credit,
  employees,
  year_options,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "PTO Requests", href: "/pto_requests" },
    { title: "PTO Credits", href: "/pto_credits" },
    { title: "Edit Credits", href: `/pto_credits/${credit.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit PTO Credits" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Edit PTO Credits</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <PtoCreditForm
            credit={credit}
            employees={employees}
            yearOptions={year_options}
            errors={errors}
            onCancel={() => router.get("/pto_credits")}
          />
        </div>
      </div>
    </AppLayout>
  )
}
